function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#BFBBB7",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.149,
  cy: 3.447,
  rx: 3.101,
  ry: 2.947
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M8.39 11.99H1.549C.523 11.854.01 11.45.01 10.78c0-1.004 1.016-4.172 4.964-4.172 1.248-.029 2.383.367 3.404 1.186"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M1.605 11.992h6.646c1.039-.089 1.559-.468 1.559-1.138 0-1.005-.841-4.244-4.79-4.244-1.255-.065-2.393.313-3.415 1.133"
}));

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.b3737001.svg";
export { ForwardRef as ReactComponent };